<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div class="">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest max-100 text-primary">Scheuren</h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Ziet u scheuren in de gevel?</h5>
      <div class="d-flex flex-column flex-lg-row justify-content-center">

        <!-- form 1 card -->
        <base-card outer-class="w-100" inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">
<!-- 
            <div class="mb-4">
                <checkmark-item class="mb-2" icon="exclamation-circle-fill">
                  Meet nu de voeg op.
                </checkmark-item>
            </div> -->

            <!-- inputs -->
            <base-input
              type="buttongrid" :options="crackingTypeOptions"
              name="Cracking"
              button-grid-input-type="radio"
              :min-col-width="100"
              :max-cols="1"
              btn-direction="row"
              :dim-label-on-value="false"
              :show-input="false"
              v-model:value="lead.cavity_wall.defects.Cracking" :validator="v$.cavity_wall.defects.Cracking">
              Zie u scheuren? Welke foto past het beste?
            </base-input>
            <issue-feedback :issue="qualStore.sections.cavity_wall.rules.Cracking" />

          </base-form>
        <!-- form card end -->
        </base-card>
      
      <!-- cards wrapper end -->
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.cavity_wall.defects.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  /* eslint-disable */
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  // import VariablePill from "@/components/VariablePill.vue"
  import CheckmarkItem from "@/components/CheckmarkItem.vue"
  import IssueFeedback from "@/components/IssueFeedback.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      // VariablePill,
      CheckmarkItem,
      IssueFeedback
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        crackingTypeOptions: [
          {
            label: 'Geen scheuren zichtbaar',
            value: 'Geen',
            icon: 'bi-slash-circle'
          },
          {
            label: 'Kleine scheur in 1 of enkele stenen',
            value: 'Kleine scheur',
            image: '/img/cracking/haarscheur.jpg',
            imageRounded: true,
            imageStyle: {
              width: '100px',
              height: '100px'
            }
          },
          {
            label: 'Scheur over meerdere stenen',
            value: 'Grotere scheur',
            image: '/img/cracking/grote-scheur.jpg',
            imageRounded: true,
            imageStyle: {
              width: '100px',
              height: '100px'
            }
          }
        ]
      };
    },
    computed: {

    },
    methods: {
      touchAndValidate() {
        this.v$.ownership.$touch();
        return !this.v$.ownership.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    }
  }
</script>

<style lang="scss">
</style>